export const env = {
    production: false,
    debugMode: true,
    url_base: 'https://dev-agata.cic-ware.com',
    api: '/api',
    landing: '/landing',
    perfil_usuario: '/perfil-usuario',
    administracion: '/administracion',
    crm: '/crm',
    asistente: '/asistente',
}

export const python = {
    production: false,
    debugMode: true,

    url_base: 'https://dev-pu.cic-ware.com/ask',
    url_asis: 'https://dev.catia.catastroantioquia-mas.com:5002/ask',
    url_var_env_crm:'https://dev-agata.cic-ware.com/ask',
    catia: '/catia',
}

 export const python_countries = {
     production: false,
     debugMode: true,

     url_base: 'https://cnx.cic-ware.com:5000',
     api : '/api',
 }
